<p-selectButton
  [style.--button-group-alignment]="alignment"
  [class.lx-button-group--start]="['start', 'flex-start'].includes(alignment)"
  [class.lx-button-group--end]="['end', 'flex-end'].includes(alignment)"
  [class.lx-button-group--center]="alignment === 'center'"
  [class.lx-button-group--grouped]="grouped"
  [class.lx-button-group--rounded]="rounded"
  [class.lx-button-group--mobile]="isMobile"
  [class.lx-button-group--show-icon]="showIconOnSelected"
  class="lx-button-group lx-filter__options"
  [options]="items"
  [(ngModel)]="selectedValue"
  optionLabel="text"
  optionValue="value"
  (ngModelChange)="onItemClick($event)"
>
  <ng-template let-item pTemplate>
    <div class="lx-button-group-item" [class.lx-button-group-item--with-icon]="item.icon">
      <ng-container [ngTemplateOutlet]="item.icon ? iconItemTpl : defaultItemTpl" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    </div>
  </ng-template>
</p-selectButton>

<ng-template #iconItemTpl let-item>
  <span
    class="lx-button-group-item__icon"
    [class.lx-button-group-item__icon-all]="item.icon === 'all'"
    [class.lx-button-group-item__icon-adults]="item.icon === 'adults'"
    [class.lx-button-group-item__icon-juniors]="item.icon === 'juniors'"
  ></span>
  <div class="lx-button-group-item__text-container">
    <span class="p-button-label" [attr.data-qa]="'lx-button-group-item-' + item.index">{{ item.text }}</span>
    <span class="p-button-label lx-button-group-item__subtitle" *ngIf="item.subtitle">{{ item.subtitle }}</span>
  </div>
</ng-template>

<ng-template #defaultItemTpl let-item>
  <span class="p-button-label" [attr.data-qa]="'lx-button-group-item-' + item.index">{{ item.text }}</span>
</ng-template>
